import React from "react";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>Új menüpont szakmai anyagokkal – Információk</h1>
		<p>
			A bal oldali menüsávban új funkcióként elérhető az Információk
			menüpont, melyre kattintva hasznos információkat, szakmai
			protokollokat, valamint egyéb tájékoztató anyagokat gyűjtöttünk
			össze a referálási folyamat támogatásához.
		</p>
	</section>
);
